import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getApiErrorMessage } from "@/modules/common/utils/apiError";
import { ADMIN_LEADS_ENDPOINTS, AdminLeadsService } from "@/service/api/admin-leads";

interface UseCreateLeadParams {
  onSuccess?: () => void;
}

const useCreateLead = ({ onSuccess }: UseCreateLeadParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: AdminLeadsService.create,
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Erro ao cadastrar lead. Tente novamente mais tarde."), { toastId: "create_lead_error" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADMIN_LEADS_ENDPOINTS.LIST] });
      queryClient.invalidateQueries({ queryKey: [ADMIN_LEADS_ENDPOINTS.SUMMARY] });
      onSuccess?.();
    },
  });
};

export default useCreateLead;
